/**
 * Set up a ResizeObserver observing the element and call the callback when the
 * element is resized. The observer is disconnected when the abortSignal fires.
 * @param {HTMLElement} element
 * @param {AbortSignal} abortSignal
 * @param {(entry: ResizeObserverEntry) => void} callback
 */
export function onResize(element, abortSignal, callback) {
  const resizeObserver = new ResizeObserver(([entry]) => callback(entry));
  resizeObserver.observe(element, { box: "border-box" });
  abortSignal.addEventListener("abort", () => {
    resizeObserver.disconnect();
  });
}
